import React from 'react';
import styles from './onboarding.module.css';
import WeekAnimation from '../WeekAnimation';

export default function TimeRequirement() {
    return (
        <>
            <div></div> {/* Empty div for centering */}
            <div className={styles.flexDiv} style={{ margin: "0 0.2rem", gap: '1rem' }}>
                <h1 className={styles.onboardingGreeting} style={{ marginBottom: "0.5rem" }}>
					5 minutes
                </h1>
                <div>
                    <p className={styles.onboardingSubgreeting}>
                        <span style={{fontWeight: 500}}>Spread over the week</span>
                    </p>
                    <WeekAnimation />
                </div>
                <div style={{ textAlign: "center", marginTop: '1rem' }}>
                    <p className={styles.para} style={{marginBottom: '1.5rem'}}>No overthinking. <br/>No second-guessing.</p>
                    <p className={styles.para} style={{ margin: "0" }}>Just a quick round of prompts.</p>
                    <p className={styles.para} style={{ margin: "0" }}>Easy like a lazy river.</p>
                </div>
            </div>
        </>
    );
}
